import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { ChainProvider } from "./context/ChainContext";
import { WebSocketProvider } from "./context/WebSocketContext";
import { Toaster } from "./components/ui/sonner";
import { AdminKeyDialog } from "./components/AdminKeyDialog";
import Layout from "./components/Layout";
import { PasswordGate } from "./components/PasswordGate";
import Dashboard from "./pages/Dashboard";
import TokenDetail from "./pages/TokenDetail";
import AddressPage from "./pages/AddressPage";
import TransactionPage from "./pages/TransactionPage";
import BlockPage from "./pages/BlockPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import LabelsPage from "./pages/LabelsPage";
import ContractsPage from "./pages/ContractsPage";
import ArchivePage from "./pages/ArchivePage";
import FirstBuysPage from "./pages/FirstBuysPage";
import BundleCalcPage from "./pages/BundleCalcPage";
import SwapSimulatorPage from "./pages/SwapSimulatorPage";
import ExplorerHome from "./pages/ExplorerHome";
import MCAddressPage from "./pages/MCAddressPage";
import MCTokenPage from "./pages/MCTokenPage";
import "./App.css";

function App() {
  return (
    <ThemeProvider>
      <PasswordGate>
        <BrowserRouter>
          <ChainProvider>
            <WebSocketProvider>
              <Layout>
                <Routes>
                  {/* Search-first Explorer is the home page (multichain). */}
                  <Route path="/" element={<ExplorerHome />} />
                  <Route path="/explorer" element={<ExplorerHome />} />
                  <Route path="/swap-simulator" element={<SwapSimulatorPage />} />
                  <Route path="/bundle" element={<BundleCalcPage />} />
                  <Route path="/analytics" element={<AnalyticsPage />} />
                  <Route path="/labels" element={<LabelsPage />} />
                  <Route path="/contracts" element={<ContractsPage />} />
                  <Route path="/archive" element={<ArchivePage />} />
                  <Route path="/firstbuys" element={<FirstBuysPage />} />
                  <Route path="/explorer/:chain/address/:address" element={<MCAddressPage />} />
                  <Route path="/explorer/:chain/token/:tokenAddress" element={<MCTokenPage />} />
                  {/* Legacy Krown-chain routes (still reachable; Krown is just another chain). */}
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/token/:tokenAddress" element={<TokenDetail />} />
                  <Route path="/address/:address" element={<AddressPage />} />
                  <Route path="/tx/:txHash" element={<TransactionPage />} />
                  <Route path="/block/:blockNumber" element={<BlockPage />} />
                </Routes>
              </Layout>
              <Toaster position="bottom-right" richColors />
              <AdminKeyDialog />
            </WebSocketProvider>
          </ChainProvider>
        </BrowserRouter>
      </PasswordGate>
    </ThemeProvider>
  );
}

export default App;
